import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import AuthProviderWrapper from './components/AuthProviderWrapper';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './components/HomePage';
import MembresiasPage from './components/MembresiasPage';
import ClubEmpresarialPage from './components/ClubEmpresarialPage';
import ConceptStorePage from './components/ConceptStorePage';
import Dashboard from './components/Dashboard';
import EventoDetalle from './components/EventoDetalle';

function App() {
  return (
    <Router>
      <AuthProviderWrapper>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/membresias" element={<MembresiasPage />} />
          <Route path="/club-empresarial" element={<ClubEmpresarialPage />} />
          <Route path="/concept-store" element={<ConceptStorePage />} />
          <Route path="/evento/:id" element={<EventoDetalle />} />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </AuthProviderWrapper>
    </Router>
  );
}

export default App;
